import { Layer, Toggle } from "@carbon/react";
import { FC, useEffect, useState } from "react";

import { TableToolbarFilter } from "src/components/Tables/TableToolbarFilter.tsx";
import { useT } from "src/internationalization";

export type AlertsAndExecutionsFilterProps = {
  onApplyFilter: (values: FilterState) => void;
  onResetFilter: () => void;
  values: FilterState;
};

type FilterState = {
  onlyOpenAlerts: boolean;
};

export const AlertsAndExecutionsFilter: FC<AlertsAndExecutionsFilterProps> = ({
  onApplyFilter,
  onResetFilter,
  values,
}) => {
  const [onlyOpenAlerts, setOnlyOpenAlerts] = useState(values.onlyOpenAlerts);
  const t = useT();

  useEffect(() => {
    setOnlyOpenAlerts(values.onlyOpenAlerts);
  }, [values]);

  return (
    <TableToolbarFilter
      onApplyFilter={() => onApplyFilter({ onlyOpenAlerts })}
      onResetFilter={onResetFilter}
      onPopoverClose={() => setOnlyOpenAlerts(values.onlyOpenAlerts)}
      numberOfFiltersApplied={values.onlyOpenAlerts ? 1 : 0}
    >
      <Layer level={2} className="w-[500px]">
        <Toggle
          id="onlyOpenAlerts"
          labelA={t("page.case.tab.alerts.and.executions.filter.onlyOpenAlerts")}
          labelB={t("page.case.tab.alerts.and.executions.filter.onlyOpenAlerts")}
          size="sm"
          toggled={onlyOpenAlerts}
          onToggle={setOnlyOpenAlerts}
        />
      </Layer>
    </TableToolbarFilter>
  );
};
